<style scoped lang="scss">
.gantt_split_parent,
.gantt_split_subproject {
  opacity: 0;
}

::v-deep .gantt_task_line.gantt_task_inline_color .gantt_task_progress {
  background-color: transparent;
  opacity: 1;
}

::v-deep .gantt_task_line.gantt_task_inline_color {
  border-color: transparent;
}

::v-deep .scale_class {
  background-color: #f5f7fa !important;
  color: #454545 !important;
}

::v-deep .scale_weekend {
  color: #454545 !important;
  background-color: #ecf5ff !important;
}

::v-deep .grid_class {
  background-color: #f5f7fa !important;
}

::v-deep .column_weekend {
  background-color: #ecf5ff !important;
}

::v-deep .gantt_task_line {
  border: none !important;
  border-radius: 0px;
}
</style>
<style lang="scss"></style>
<template>
  <div id="device_load_gantt" style="width: 100%;height: 100%;padding: 20px;display:flex;flex-direction: column;" :style="{ width: '100%', height: '100%' }">
    <div>
      <el-form size="mini" :inline="true" class="demo-form-inline">
        <el-form-item :label="$t('shijianfanwei')">
          <yi_time_input type="datetimerange" :start.sync="startTime" :end.sync="endTime" :clearable="false"> </yi_time_input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="setTimeRangeLoading" @click="setTimeRange()" type="primary" plain="plain">
            {{ $t("sousuo") }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-form size="mini" :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button @click="xinzeng()" type="primary">
            {{ $t("xinzengtingchanjihua") }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="shanchu()" type="danger" :disabled="currentId == null">
            {{ $t("shanchutingchanjihua") }}
          </el-button>
<!--          <el-popconfirm :title="$t('querenshanchu?')" @confirm="shanchu()">-->
<!--            <el-button slot="reference" type="danger" :disabled="currentId == null">-->
<!--              {{ $t("shanchutingchanjihua") }}-->
<!--            </el-button>-->
<!--          </el-popconfirm>-->
        </el-form-item>
      </el-form>
    </div>
    <div style="width:100%;flex:1;" class="ganttContainer" ref="factoryGanttContainer"></div>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t('xinzeng')" :visible.sync="isShowEditDialog" width="502px" :close-on-click-modal="false" append-to-body="append-to-body" label-position="right">
      <el-form :inline="true" ref="form" size="mini" :label-width="'147px'">
        <el-form-item :label="$t('tingchanjihuamingcheng')" required>
          <el-input v-model="editObj.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('tingchanleixing')" required>
          <yi_dictionary_select :type="'SHUTDOWN_TYPE'" :ids.sync="editObj.shutdownType"> </yi_dictionary_select>
        </el-form-item>
        <el-form-item v-show="editObj.shutdownType == '2'" :label="$t('anzhouzhiding')" required>
          <yi_dictionary_select :type="'SPECIFY_BY_WEEK'" :ids.sync="editObj.weekly"> </yi_dictionary_select>
        </el-form-item>
        <el-form-item v-show="editObj.shutdownType == '1'" :label="$t('tingchankaishishijian')" required>
          <yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime" :time.sync="editObj.specifyStartTime"> </yi_time_input>
        </el-form-item>
        <el-form-item v-show="editObj.shutdownType == '1'" :label="$t('tingchanjieshushijian')" required>
          <yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime" :time.sync="editObj.specifyEndTime"> </yi_time_input>
        </el-form-item>
        <el-form-item v-show="editObj.shutdownType == '2'" :label="$t('anzhoutingchankaishishijian')" required>
          <el-time-picker v-model="editObj.weekStartTime" value-format="HH:mm:ss"> </el-time-picker>
        </el-form-item>
        <el-form-item v-show="editObj.shutdownType == '2'" :label="$t('anzhoutingchanjieshushijian')" required>
          <el-time-picker v-model="editObj.weekEndTime" value-format="HH:mm:ss"> </el-time-picker>
        </el-form-item>
        <el-form-item :label="$t('miaoshu')">
          <el-input v-model="editObj.remark"></el-input>
        </el-form-item>
      </el-form>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
        <el-button :loading="createPlanLoading" size="mini" @click="createPlan()" type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
    <el-drawer :visible.sync="isShowDetailDialog" :show-close="false" :direction="'rtl'" :size="374" :destroy-on-close="true" :withHeader="false" :append-to-body="true">
      <div style="margin: 40px 28px;">
        <el-descriptions :column="1">
          <el-descriptions-item :label="$t('tingchanjihuamingcheng')">{{ currentPlan.name }} </el-descriptions-item>
          <el-descriptions-item :label="$t('tingchanleixing')">
            {{ $t(store.state.dictJsonAll["SHUTDOWN_TYPE"][currentPlan.shutdownType + ""]) }}
          </el-descriptions-item>
          <el-descriptions-item v-if="currentPlan.shutdownType == '2'" :label="$t('anzhouzhiding')">
            {{ $t(store.state.dictJsonAll["SPECIFY_BY_WEEK"][currentPlan.weekly + ""]) }}
          </el-descriptions-item>
          <el-descriptions-item v-if="currentPlan.shutdownType == '1'" :label="$t('tingchankaishishijian')">
            {{ dayjs.unix(currentPlan.specifyStartTime / 1000).format("YYYY-MM-DD HH:mm:ss") }}
          </el-descriptions-item>
          <el-descriptions-item v-if="currentPlan.shutdownType == '1'" :label="$t('tingchanjieshushijian')">
            {{ dayjs.unix(currentPlan.specifyEndTime / 1000).format("YYYY-MM-DD HH:mm:ss") }}
          </el-descriptions-item>
          <el-descriptions-item v-if="currentPlan.shutdownType == '2'" :label="$t('anzhoutingchankaishishijian')">
            {{ currentPlan.weekStartTime }}
          </el-descriptions-item>
          <el-descriptions-item v-if="currentPlan.shutdownType == '2'" :label="$t('anzhoutingchanjieshushijian')">
            {{ currentPlan.weekEndTime }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('miaoshu')">
            {{ currentPlan.remark }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/javascript">
import html2canvas from "html2canvas";
const gantt = Gantt.getGanttInstance();

export default {
  name: "web_scheduling_factory_calendar_calendar_gantt_index",
  components: {},
  data() {
    return {
      currentId: null,
      isShowEditDialog: false,
      isShowDetailDialog: false,
      setTimeRangeLoading: false,
      createPlanLoading: false,
      editObj: {},
      startTime: this.dayjs()
        .startOf("month")
        .valueOf(),
      endTime: this.dayjs()
        .endOf("month")
        .valueOf(),
      tasks: {
        data: [],
      },
      plans: [],
      currentPlan: {},
    };
  },
  created() {
    // this.$watch("editObj.specifyStartTime", (newVal, oldVal) => {
    // 	// 在这里执行判断逻辑
    // 	this.checkEndTime();
    // });
    // // 添加 watch 来监视 yt.editObj.specifyEndTime 的变化
    // this.$watch("editObj.specifyEndTime", (newVal, oldVal) => {
    // 	// 在这里执行判断逻辑
    // 	this.checkEndTime();
    // });
    // // 添加 watch 来监视 yt.editObj.weekEndTime 的变化
    // this.$watch("editObj.weekEndTime", (newVal, oldVal) => {
    // 	// 在这里执行判断逻辑
    // 	this.checkWeekEndTime();
    // });
    // this.$watch("editObj.weekStartTime", (newVal, oldVal) => {
    // 	// 在这里执行判断逻辑
    // 	this.checkWeekEndTime();
    // });
  },
  destroyed() {
    gantt.clearAll();
  },
  mounted() {
    // gantt.config.autosize = true
    // gantt.setWorkTime({hours:["00:00-23:59"]})
    gantt.config.scale_height = 50;
    gantt.config.min_column_width = 80;
    gantt.config.time_step = 1;
    gantt.i18n.setLocale("cn");
    gantt.config.duration_unit = "minute";
    gantt.config.drag_links = false;
    gantt.config.drag_move = false;
    gantt.config.drag_progress = false;
    gantt.config.drag_resize = false;
    gantt.config.date_format = "%Y-%m-%d %H:%i";
    gantt.templates.grid_file = function(item) {
      return "";
    };
    gantt.templates.scale_row_class = function(scale) {
      return "scale_class";
    };
    gantt.templates.grid_header_class = function(columnName, column) {
      return "grid_class";
    };
    gantt.templates.grid_row_class = function(columnName, column) {
      return "grid_class";
    };
    gantt.templates.timeline_cell_class = function(task, date) {
      if (date.getDay() == 0 || date.getDay() == 6) {
        return "column_weekend";
      }
    };

    gantt.config.scales = [
      {
        unit: "month",
        step: 1,
        format: "%Y" + this.$t("nian") + "%M",
        css: function(date) {
          return "scale_class";
        },
      },
      {
        unit: "day",
        step: 1,
        format: "%d",
        css: function(date) {
          if (date.getDay() == 0 || date.getDay() == 6) {
            return "scale_weekend";
          } else {
            return "scale_class";
          }
        },
      },
    ];
    gantt.config.columns = [
      {
        name: "text",
        label: "<img style='object-fit: contain;width: 136px;height: 50px' src='" + require("@@/assets/img/web/production_management/gantt-task1.svg") + "' />",
        tree: true,
        width: 136,
      },
    ];
    gantt.attachEvent("onTaskClick", (id, e) => {
      //this.getGanttDetail(id)
      //return false就不会执行默认的弹框操作
      this.currentId = id.split("_")[0];
      return true;
    });
    gantt.attachEvent("onTaskDblClick", (id, e) => {
      //this.getGanttDetail(id)
      //return false就不会执行默认的弹框操作
      this.currentId = id.split("_")[0];
      this.getGanttDetail(id.split("_")[0]);
      return false;
    });
    gantt.addCalendar({
      id: "custom", // optionalworktime: {hours: ["8:00-17:00"],days: [ 1, 1, 1, 1, 1, 1 ,1]}
    });

    this.getGantt();
  },
  methods: {
    checkWeekEndTime() {
      if (this.yt.editObj.shutdownType != null && this.yt.editObj.shutdownType != undefined) {
        if (this.editObj.weekStartTime == null || this.editObj.weekStartTime == undefined) {
          this.$message.error(this.$t("qingxuanzekaishishijian"));
          this.editObj.weekEndTime = new Date(); // 清除结束时间
          return;
        }
      }
      const weekStartTime = this.editObj.weekStartTime;
      const weekEndTime = this.editObj.weekEndTime;

      if (weekStartTime && weekEndTime) {
        const startTime = new Date(`1970-01-01 ${weekStartTime}`);
        const endTime = new Date(`1970-01-01 ${weekEndTime}`);

        if (startTime > endTime) {
          this.$message.error(this.$t("jieshushijianbunengzaoyukaishishijian"));
          console.log("我输出了一次");
          // 如果需要，可以重置值
          this.editObj.weekEndTime = new Date(); // 清除结束时间
          return;
        }
      }
    },
    checkEndTime() {
      if (this.yt.editObj.shutdownType != null && this.yt.editObj.shutdownType != undefined) {
        if (this.editObj.specifyStartTime == null || this.editObj.specifyStartTime == undefined) {
          this.$message.error(this.$t("qingxuanzekaishishijian"));
          this.editObj.specifyEndTime = new Date().getTime();
        }
      }
      const specifyStartTime = new Date(this.editObj.specifyStartTime).getTime();
      const specifyEndTime = new Date(this.editObj.specifyEndTime).getTime();

      if (specifyEndTime < specifyStartTime) {
        // 处理错误，例如显示一条消息
        this.$message.error(this.$t("jieshushijianbunengzaoyukaishishijian"));
        // 如果需要，你可以将 yt.editObj.specifyEndTime 重置为旧值
        this.editObj.specifyEndTime = new Date().getTime();
      }
    },
    xinzeng() {
      this.editObj = {};
      this.isShowEditDialog = true;
    },
    shanchu() {
      this.$confirm(this.$t('querenshanchu?'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        showCancelButton: true,
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            // 在确定按钮点击时添加loading效果
            instance.confirmButtonLoading = true;
            // 执行操作...
            // 操作完成后，手动关闭对话框
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 2000);
          } else {
            // 取消按钮点击或者点击遮罩层时，直接关闭对话框
            done();
          }
        }
      }).then(() => {
        let params = {};
        params.id = parseInt(this.currentId);
        this.http
            .post("/web/equipment/production/cessation/plan/delete", params)
            .then((res) => {
              this.currentId = null;
              this.getGantt();
            })
            .catch((error) => {
              this.utils.errorMessage(error);
            });
      }).catch(() => {
        // 取消按钮点击或者点击遮罩层时的操作
      });

    },
    createPlan() {
      this.createPlanLoading = true
      let params = this.utils.copy(this.editObj);
      params.factoryCalendarId = this.$attrs.factoryCalendarId;
      this.http
        .post("/web/equipment/production/cessation/plan/create", params)
        .then((res) => {
          console.log(res);
          this.isShowEditDialog = false;
          this.getGantt();
          this.createPlanLoading = false
        })
        .catch((error) => {
          this.utils.errorMessage(error);
          this.createPlanLoading = false
        });
    },
    setTimeRange() {
      this.getGantt();
    },
    getGanttDetail(id) {
      for (var i = 0; i < this.plans.length; i++) {
        if (this.plans[i].id == id) {
          this.currentPlan = this.plans[i];
          break;
        }
      }
      this.isShowDetailDialog = true;
    },
    getGantt() {
      this.setTimeRangeLoading = true
      gantt.clearAll();
      this.currentId = null;
      this.http
        .get("/web/equipment/production/cessation/plan/list", {
          params: {
            factoryCalendarId: this.$attrs.factoryCalendarId,
          },
        })
        .then((res) => {
          this.plans = res.data;
          let data = [];
          for (var i = 0; i < res.data.length; i++) {
            let plan = res.data[i];

            if (plan.shutdownType == "1") {
              let countStartTime = plan.specifyStartTime >= this.startTime ? plan.specifyStartTime : this.startTime;
              let countEndTime = plan.specifyEndTime >= this.endTime ? this.endTime : plan.specifyEndTime;

              data.push({
                id: plan.id,
                text: plan.name,
                start_date: new Date(this.startTime),
                duration: 0,
                progress: 0,
                render: "split",
                parent: null,
                type: "subproject",
                // color:'transparent',
                textColor: "transparent",
              });

              data.push({
                id: plan.id + "_",
                // text: this.dayjs.unix(plan.specifyStartTime / 1000).format(
                // 	'YYYY-MM-DD HH:mm:ss')+"-"+this.dayjs.unix(plan.specifyEndTime / 1000).format(
                // 	'YYYY-MM-DD HH:mm:ss'),
                text: plan.remark ? plan.remark : this.$t("chakanxiangqing"),
                start_date: this.dayjs.unix(countStartTime / 1000).format("YYYY-MM-DD HH:mm:ss"),
                duration: (countEndTime - countStartTime) / 1000 / 60,
                progress: 1,
                parent: plan.id,
                color: "#FEF0F0",
                textColor: "#F56C6C",
              });
            }
            if (plan.shutdownType == "2") {
              //找出本月的周六和周日
              let start = this.dayjs(this.starTime);
              let end = this.dayjs(this.endTime);
              let weekly = parseInt(plan.weekly);
              var arr = [];
              // Get "next" monday
              let six = start.clone().day(weekly);
              if (six.isAfter(start, "d")) {
                arr.push(six.format("YYYY-MM-DD"));
                six = six.add(7, "days");
              }
              while (six.isBefore(end)) {
                arr.push(six.format("YYYY-MM-DD"));
                six = six.add(7, "days");
              }

              for (var j = 0; j < arr.length; j++) {
                let weekStartTime = this.dayjs(arr[j] + " " + plan.weekStartTime).valueOf();
                let weekEndTime = this.dayjs(arr[j] + " " + plan.weekEndTime).valueOf();

                let countStartTime = weekStartTime >= this.startTime ? weekStartTime : this.startTime;
                let countEndTime = weekEndTime >= this.endTime ? this.endTime : weekEndTime;

                if (j == 0) {
                  data.push({
                    id: plan.id,
                    text: plan.name,
                    start_date: this.dayjs.unix(countStartTime / 1000).format("YYYY-MM-DD HH:mm:ss"),
                    duration: 0,
                    progress: 0,
                    render: "split",
                    parent: null,
                    type: "subproject",
                    // color:'transparent',
                    textColor: "transparent",
                  });
                }
                data.push({
                  id: plan.id + "_" + j,
                  text: plan.remark ? plan.remark : "",
                  start_date: this.dayjs.unix(countStartTime / 1000).format("YYYY-MM-DD HH:mm:ss"),
                  duration: (countEndTime - countStartTime) / 1000 / 60,
                  progress: 1,
                  parent: plan.id,
                  color: "#FEF0F0",
                  textColor: "#F56C6C",
                });
              }
            }
          }
          console.log(data);
          this.tasks.data = data;
          gantt.init(this.$refs.factoryGanttContainer);
          gantt.parse(this.tasks);

          gantt.config.start_date = new Date(this.startTime);
          gantt.config.end_date = new Date(this.endTime);
          this.setTimeRangeLoading = false
          // if (this.days == null) {
          // 	gantt.config.start_date = null;
          // 	gantt.config.end_date = null;
          // } else {
          // 	let startTime = new Date().getTime()
          // 	for (var i = 0; i < this.eqs.length; i++) {
          // 		let eq = this.eqs[i]
          // 		for (var j = 0; j < eq.taskList.length; j++) {
          // 			let wo = eq.taskList[j]
          // 			if (wo.startTime < startTime) {
          // 				startTime = wo.startTime
          // 			}
          // 		}
          // 	}

          // 	gantt.config.start_date = new Date(startTime);
          // 	gantt.config.end_date = new Date(new Date().getTime() + this.days * 24 * 60 * 60 * 1000);

          // }

          setTimeout(() => {
            gantt.setSizes();
            this.setTimeRangeLoading = false
          }, 0);
        })
        .catch((error) => {
          this.setTimeRangeLoading = false
        });
    },
  },
};
</script>
